module.exports = __webpack_public_path__ + "img/avatar-890.1269cee6.png";